export default "__VITE_ASSET__f88bf0e4__"